(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Scrolling = Lfl.Scrolling || {};

    (function (Scrolling, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Scrolling, 'InfiniteScrolling')) {
            return;
        }

        /**
         * Registers ajax loaded infinite scrolling list.
         *
         * @memberOf Lfl.Scrolling
         */
        Lfl.Scrolling.InfiniteScrolling = Scrolling.InfiniteScrolling || {};

        (function (InfiniteScrolling, $, undefined) {
            /**
             * @type {string}
             */
            const LOADING_SPINNER_QUERY = '.loading-spinner';

            /**
             * @type {string}
             */
            const NEXT_PAGE_QUERY = '#next-page-url';

            /**
             * @type string
             */
            let nextPageUrl;

            /**
             * @type string
             */
            let loadingIndicatorSelector;

            /**
             * @type {boolean}
             */
            let loading = false;

            /**
             * @type {function}
             */
            let successCallback;

            /**
             * @type {jQuery}
             */
            let $loadingSpinner;

            /**
             * @type boolean
             */
            let showIndicatorWhenIdle;

            /**
             * @type boolean
             */
            let inverted;

            /**
             * @param {Object} parameters
             * @param {string} parameters.nextPageUrl - Initial url to load next page
             * @param {string} parameters.loadingIndicatorSelector - Initial url to load next page
             * @param {function} parameters.successCallback - Handler function to parse page response
             * @param {boolean|undefined} parameters.showIndicatorWhenIdle - Show indicator even when not loading
             * @param {boolean|undefined} parameters.inverted - True for scrolling detection on top of screen
             * @memberOf Lfl.Scrolling.InfiniteScrolling
             */
            InfiniteScrolling.init = function(parameters) {
                nextPageUrl = parameters.nextPageUrl;
                loadingIndicatorSelector = parameters.loadingIndicatorSelector;
                successCallback = parameters.successCallback;
                inverted = parameters.inverted ?? false;
                showIndicatorWhenIdle = parameters.showIndicatorWhenIdle ?? false;

                if (false === hasNextPage() || false === showIndicatorWhenIdle) {
                    hideLoadingIndicator();
                } else {
                    showLoadingIndicator()
                }

                registerScrollingEventListeners();
            };

            /**
             * @memberOf Lfl.Scrolling.InfiniteScrolling
             */
            InfiniteScrolling.loadNextPage = function() {
                if (false === loading) {
                    if (hasNextPage()) {
                        loading = true;
                        showLoadingIndicator();

                        $.ajax({
                            url: nextPageUrl,
                            success: function (result) {
                                nextPageUrl = $(result).find(NEXT_PAGE_QUERY).text();

                                successCallback(result);

                                if (false === hasNextPage() || false === showIndicatorWhenIdle) {
                                    hideLoadingIndicator();
                                }

                                loading = false;

                                Lfl.Scrolling.InfiniteScrolling.checkScrollStateToLoad();
                            },
                            failure: function() {
                                hideLoadingIndicator();
                                loading = false;
                            },
                            error: function(xhr) {
                                Lfl.Ajax.ResponseParser.reloadIfUnauthenticated(xhr);
                            }
                        });
                    }
                }
            };

            /**
             * @param {string} newUrl
             * @memberOf Lfl.Scrolling.InfiniteScrolling
             */
            InfiniteScrolling.setNextPageUrl = function(newUrl) {
                nextPageUrl = newUrl;
            };

            InfiniteScrolling.updateList = function(data, append, contentSelector) {
                /* Handle content */
                const $content = $(contentSelector);
                const $resultContent = $(data).find(contentSelector);

                if (append) {
                    $content.append($resultContent.html());
                } else {
                    $content.replaceWith($resultContent);
                }

                /* Handle modals */
                const $modalsReplace = $('#ajax_replace_modals');
                const $resultModals = $(data).find('#ajax_replace_modals');

                if (append) {
                    $modalsReplace.append($resultModals.html());
                } else {
                    $modalsReplace.replaceWith($resultModals);
                }

                /* Handle javascript */
                const $javascriptReplace = $('#ajax_replace_javascript');
                const $resultJavascript = $(data).find('#ajax_replace_javascript');

                if (append) {
                    $javascriptReplace.append($resultJavascript.html());
                    Lfl.Tooltips.Enabler.enableNow();
                } else {
                    $javascriptReplace.replaceWith($resultJavascript);
                }
            }

            InfiniteScrolling.checkScrollStateToLoad = function() {
                if (inverted) {
                    if ($(window).scrollTop() === 0) {
                        InfiniteScrolling.loadNextPage();
                    }
                } else {
                    if ($(window).scrollTop() + $(window).height() > $(document).height() - 150) {
                        InfiniteScrolling.loadNextPage();
                    }
                }
            }

            function registerScrollingEventListeners() {
                $(window).bind('scroll load', function (event) {
                    Lfl.Scrolling.InfiniteScrolling.checkScrollStateToLoad();
                });
            }

            function showLoadingIndicator() {
                getLoadingIndicator().show();
            }

            function hideLoadingIndicator() {
                getLoadingIndicator().hide();

                /* Different behaviour on ios and safari */
                const safari = !!window.safari;
                const ios = /iPhone|iPod|iPad/.test( window.navigator.userAgent);

                if (inverted && (safari || ios)) {
                    const loadingIndicatorSizeY = getLoadingIndicator().outerHeight(true);
                    const scrollSizeY = document.documentElement.scrollHeight;
                    const windowSizeY = window.innerHeight;

                    /* Move by the size of just hidden indicator or only as far as the scroll allows */
                    const moveY = Math.min(loadingIndicatorSizeY, scrollSizeY - windowSizeY);

                    window.scrollBy(0, -moveY);
                }
            }

            function getLoadingIndicator() {
                if (typeof $loadingSpinner === 'undefined') {
                    if (typeof loadingIndicatorSelector !== 'undefined') {
                        $loadingSpinner = $(loadingIndicatorSelector);
                    } else {
                        $loadingSpinner = $(LOADING_SPINNER_QUERY);
                    }
                }

                return $loadingSpinner;
            }

            function hasNextPage() {
                return (typeof nextPageUrl !== 'undefined') && nextPageUrl.trim().length !== 0;
            }
        }(Scrolling.InfiniteScrolling, jQuery));
    }(Lfl.Scrolling, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
